module.exports = __webpack_public_path__ + "assets/je-orange-lg-logo-0cb7d2.svg";